//
//
//
//
//

    var cyberObj = require('../js/player/cyberplayer.js')
    var cyberplayer = cyberObj.cyberplayer

    export default {
        data () {
            return {
                player: {},
                websocket: {},
            }
        },
        mounted: function () {
            var url = this.$route.query.url;
            this.previewVideo(url)
        },
        beforeRouteLeave (to, from, next) {
//            if (this.websocket && typeof this.websocket.close == 'function') {
//                this.websocket.close()
//            }
            next(true)
        },
        methods: {
            startLiveWS: function (url, ak, thumbnail, sid) {
//                var vcomp = this
//                this.websocket = new WebSocket(Constant.api_web_socket + sid)
//                this.websocket.onopen = function (evnt) {
//                    console.log("websocket: on open")
//                    vcomp.previewVideo(url, ak, thumbnail)
//                };
//                this.websocket.onmessage = function (evnt) {
//                    console.log("websocket: on message")
//                    alert(evnt.data)
//                };
//                this.websocket.onerror = function (evnt) {
//                    console.log("websocket: on error")
//                    vcomp.previewVideo(url, ak, thumbnail)
//                };
//                this.websocket.onclose = function (evnt) {
//                    console.log("websocket: on close")
//                }
            },
            previewVideo: function (url, ak, thumbnail) {
                if (ak) {
                    this.player = cyberplayer("player_container").setup({
                        width: document.body.clientWidth,
                        height: document.body.clientHeight,
                        stretching: "none",
                        file: url,
                        image: thumbnail,
                        hls: {reconnecttime: 5},
                        autostart: true,
                        repeat: false,
                        volume: 100,
                        controls: 'over',
                        ak: ak
                    })
                } else {
                    this.player = cyberplayer("player_container").setup({
                        width: document.body.clientWidth,
                        height: document.body.clientHeight,
                        stretching: "uniform",
                        file: url,
                        type: 'mp4',
                        autostart: true,
                        repeat: false,
                        volume: 100,
                        controls: true,
                        ak: '3e1307fe48cd4adc91b87c58409758e8'
                    })
                }

                this.player.on('setupError', function () {
                    alert('视频播放失败，请稍后再试。');
                })
                this.player.on('error', function () {
                    alert('视频播放失败，请稍后再试。');
                })

                this.player.onLiveStop(function () {
                    alert("直播已结束，谢谢观看")
                })
                this.player.onNoLiveStream(function () {
                    alert("直播已结束，谢谢观看")
                })

            }
        }
    }



// WEBPACK FOOTER //
// ./src/views/live_player.vue